/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import user from "assets/user.svg";
import Text from "components/Common/Text";
import "./styles.css";

import { motion } from "framer-motion";

import IncreaseImg from "../../../assets/increase.svg";
import DecreaseImg from "../../../assets/decrease.svg";
import EditTees from "../../../assets/editTeesWhite.svg";
import { AnimatedNumber } from "../animatedNumber";

// eslint-disable-next-line react/prop-types
function EmptyHole({ par }) {
  return (
    <span>{par}</span>
    // <motion.span
    //   animate={{
    //     rotate: [0, -10, 10, -10, 10, 0],
    //     scale: [1, 1.2, 1, 1.2, 1],
    //     opacity: [1, 0.8, 1, 0.8, 1],
    //   }}
    //   transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
    //   style={{ display: "inline-block" }}
    // >
    //   {par}
    // </motion.span>
  );
}

function HolesItem({
  currentPar,
  currentHoleIndex,
  isCurrentUser,
  displayName,
  handicap,
  userValue,
  userNetScore,
  onDecreaseValue,
  onIncreaseValue,
  // disabled,
  ntp,
  editTeesButtonShown,
  onEditTees,
  teeName,
  kickerTypeNet,
  matchTypeNet,
  matchType,
  disableInput,
}) {
  const displayingValue = () => {
    if (matchType === 0 && kickerTypeNet) {
      if (userValue === userNetScore) {
        return <div>{userValue || <EmptyHole par={currentPar} />}</div>;
      }
      return (
        <>
          <div>{userValue}</div>
          <div>
            / NET
            {userNetScore}
          </div>
        </>
      );
    }
    if (matchTypeNet === kickerTypeNet) {
      return <div>{userValue || <EmptyHole par={currentPar} />}</div>;
    }
    if (userValue === userNetScore) {
      return <div>{userValue || <EmptyHole par={currentPar} />}</div>;
    }
    return (
      <>
        <div>{userValue}</div>
        <div>
          / NET
          {userNetScore}
        </div>
      </>
    );
  };

  const inputHoles = disableInput ? (
    <div className="holeItem--score extended-padding">{displayingValue()}</div>
  ) : (
    <div className="holeItem--buttonBlock">
      <div
        onClick={() => onDecreaseValue()}
        role="button"
        tabIndex="-1"
        aria-hidden="true"
      >
        <img src={DecreaseImg} alt="decrease" />
      </div>
      <div className="holeItem--score">{displayingValue()}</div>

      <div
        onClick={() => onIncreaseValue()}
        aria-hidden="true"
        role="button"
        tabIndex="0"
      >
        <img src={IncreaseImg} alt="increase" />
      </div>
    </div>
  );

  return (
    <>
      {isCurrentUser && (
        <AnimatedNumber
          value={currentHoleIndex + 1}
          userValue={displayingValue()}
        />
      )}
      <div className={ntp ? "homeItem--wrapper-tint" : "homeItem--wrapper"}>
        <div className="holeItem--nameBlock">
          <div className="holeItem--name">
            {isCurrentUser ? (
              <div style={{ alignItems: "center", display: "flex" }}>
                <img src={user} alt="u" style={{ marginRight: 2 }} />{" "}
                {displayName}
              </div>
            ) : (
              displayName
            )}
          </div>
          <div className="holeItem--buttonBlock">
            {teeName && (
              <Text as="C1" bold style={{ color: "#5C6363", marginRight: 4 }}>
                {teeName} •
              </Text>
            )}
            <Text as="C1" style={{ color: "#5C6363" }}>
              HCP {handicap}
            </Text>
          </div>
        </div>

        {/* <motion.div layout>
        {editTeesButtonShown ? (
          <div
            className="holeItem--buttonBlock-editTees"
            onClick={() => onEditTees()}
            aria-hidden
          >
            <img src={EditTees} alt="edit tees" />
            <Text as="P1" bold style={{ marginLeft: 4 }}>
              TEES
            </Text>
          </div>
        ) : (
          <div className="holeItem--buttonBlock">
            <div
              onClick={() => onDecreaseValue()}
              role="button"
              tabIndex="-1"
              aria-hidden="true"
            >
              <img src={DecreaseImg} alt="decrease" />
            </div>
            <div className="holeItem--score">{displayingValue()}</div>

            <div
              onClick={() => onIncreaseValue()}
              aria-hidden="true"
              role="button"
              tabIndex="0"
            >
              <img src={IncreaseImg} alt="increase" />
            </div>
          </div>
        )}
      </motion.div> */}

        <motion.div layout>
          {!isCurrentUser ? (
            <div aria-hidden>
              <div className="holeItem--score extended-padding">
                {displayingValue()}
              </div>
            </div>
          ) : (
            inputHoles
          )}
        </motion.div>
      </div>
    </>
  );
}

HolesItem.propTypes = {
  currentPar: PropTypes.number.isRequired,
  currentHoleIndex: PropTypes.number.isRequired,
  // disabled: PropTypes.bool,
  displayName: PropTypes.string.isRequired,
  handicap: PropTypes.number.isRequired,
  isCurrentUser: PropTypes.bool,
  onDecreaseValue: PropTypes.oneOfType([PropTypes.func]).isRequired,
  onIncreaseValue: PropTypes.oneOfType([PropTypes.func]).isRequired,
  userNetScore: PropTypes.number.isRequired,
  userValue: PropTypes.number.isRequired,
  ntp: PropTypes.bool.isRequired,
  editTeesButtonShown: PropTypes.bool.isRequired,
  onEditTees: PropTypes.bool.isRequired,
  teeName: PropTypes.string.isRequired,
  kickerTypeNet: PropTypes.bool.isRequired,
  matchTypeNet: PropTypes.bool.isRequired,
  matchType: PropTypes.number.isRequired,
  disableInput: PropTypes.bool,
};

HolesItem.defaultProps = {
  // disabled: false,
  isCurrentUser: false,
  disableInput: false,
};

export { HolesItem };
